// Patch 008.8 — Shared loading-state primitive.
//
// Replaces ad-hoc "<p>Loading…</p>" text on Track 2 pages with shimmering
// dark-surface blocks. Three variants cover the current need: title (one
// gold-soft accent line), card (rectangular block matching .hcc-card
// dimensions), and text (thin lines, repeatable). All variants animate via
// the same .hcc-skeleton base — no per-variant animation overrides.

type Variant = 'title' | 'card' | 'text'

export function Skeleton(props: {
  variant?: Variant
  count?: number
  width?: string
  testId?: string
}): JSX.Element {
  const variant = props.variant ?? 'card'
  const count = props.count ?? 1
  return (
    <div
      className="hcc-skeleton-list"
      data-testid={props.testId ?? `skeleton-${variant}`}
      aria-busy="true"
      aria-live="polite"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`hcc-skeleton hcc-skeleton--${variant}`}
          style={props.width ? { width: props.width } : undefined}
        />
      ))}
    </div>
  )
}
